<div id="top-header" class="container-fluid bg-white px-0" [ngClass]="showEnvWarning ? 'env-bg' : ''">

  <div class="row no-gutters">
    <div class="col-lg header-container d-flex justify-content-between align-items-center">
      <div *ngIf="!showEnvWarning" class="header-logo-prod" aria-label="logo">
        <img src="assets/img/logo_noovle.svg" class="" alt="logo" />
      </div>
      <div *ngIf="showEnvWarning" class="header-logo" aria-label="logo">
        <img src="assets/img/header_logo_showEnvWarning.svg" class="" alt="logo" />
      </div>
      <div *ngIf="showEnvWarning" class="env-type">        
        <img src="assets\ico\exclamation-triangle-regular-env.svg" width="29px" alt="alert">
        <span class="title">{{'dashboard.envWarning' | translate}}</span>
    </div>
      <div class="d-flex align-items-center">
        <div>
          <apc-search-autocomplete *checkPermission="{ role: 'viewer'}"  [showEnvWarning]="showEnvWarning"></apc-search-autocomplete>
        </div>
        <div ngbDropdown placement="bottom-right" class="header-cog">
          <button class="btn" [ngClass]="showEnvWarning ? 'icon fill-white' : ''" id="session-menu" ngbDropdownToggle [inlineSVG]="'assets/ico/cog-regular.svg'"></button>
          <div ngbDropdownMenu aria-labelledby="session-menu" style="width: 250px;">
            <div ngbDropdownItem (click)="refreshPermissions()">
              <div class="row menu-button">
                <div class="icon action-icon" aria-label="homepage" [inlineSVG]="'assets/ico/sync-alt-regular.svg'"></div>
                <div class="button-text">{{'header.refreshPermissions' | translate}}</div>
              </div>
            </div>
            <div ngbDropdownItem (click)="logout()">
              <div class="row menu-button">
                <div class="icon action-icon" aria-label="homepage" [inlineSVG]="'assets/ico/sign-out-regular.svg'"></div>
                <div class="button-text">{{'header.logout' | translate}}</div>
              </div>
            </div>
            <div ngbDropdownItem class="disabled">
              <div class="row menu-button">                
                <div class="button-text version-text">Last Build: {{version}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>